document.addEventListener("DOMContentLoaded", function () {
  function resizeSelect(select) {
    const temp = document.createElement("span");
    temp.style.visibility = "hidden";
    temp.style.position = "absolute";
    temp.style.whiteSpace = "nowrap";
    temp.style.font = window.getComputedStyle(select).font;
    temp.textContent = select.options[select.selectedIndex].text;

    document.body.appendChild(temp);
    const width = temp.offsetWidth + 45;
    select.style.width = `${width}px`;
    temp.remove();
  }

  function initSelects() {
    document.querySelectorAll('.sls-select').forEach(select => {
      if (!select.dataset.resized) { 
        resizeSelect(select);
        select.addEventListener('change', () => resizeSelect(select));
        select.dataset.resized = "true"; 
      }
    });
  }

  initSelects();

  const observer = new MutationObserver(initSelects);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});